import { withSubscribe } from '#lib/withSubscribe';
import { useSmartBarFocusHotkey } from '#platform/web/useSmartBarFocusHotkey';

/**
 * Component used to setup the hotkey listener to focus smart bar
 */
export const SetupSmartBarFocusHotkey = withSubscribe(() => {
  useSmartBarFocusHotkey();

  return null;
});
